var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlignLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 1.89062H16.4375C16.8281 1.89062 17.1406 1.58594 17.1406 1.19531C17.1406 0.8125 16.8281 0.5 16.4375 0.5H1.6875C1.29688 0.5 0.992188 0.8125 0.992188 1.19531C0.992188 1.58594 1.29688 1.89062 1.6875 1.89062ZM1.6875 5.98438H10.4453C10.8359 5.98438 11.1484 5.67969 11.1484 5.28906C11.1484 4.89844 10.8359 4.59375 10.4453 4.59375H1.6875C1.29688 4.59375 0.992188 4.89844 0.992188 5.28906C0.992188 5.67969 1.29688 5.98438 1.6875 5.98438ZM1.6875 10.0781H16.4375C16.8281 10.0781 17.1406 9.77344 17.1406 9.38281C17.1406 8.99219 16.8281 8.6875 16.4375 8.6875H1.6875C1.29688 8.6875 0.992188 8.99219 0.992188 9.38281C0.992188 9.77344 1.29688 10.0781 1.6875 10.0781ZM1.6875 14.1719H10.4453C10.8359 14.1719 11.1484 13.8594 11.1484 13.4766C11.1484 13.0859 10.8359 12.7812 10.4453 12.7812H1.6875C1.29688 12.7812 0.992188 13.0859 0.992188 13.4766C0.992188 13.8594 1.29688 14.1719 1.6875 14.1719Z",
    fill: "#B2B2BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlignLeft);
export default __webpack_public_path__ + "static/media/icon-align-left.b0a8819f43f06562ff34039d51ef54c2.svg";
export { ForwardRef as ReactComponent };